var React = require('react');

function External (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Externe link"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":1},React.createElement("g",{"transform":"translate(0.000000, 1.000000)","stroke":"#004CA0"},React.createElement("g",null,[React.createElement("path",{"d":"M0.971557617,7.02844238 L8,0","key":0}),React.createElement("polyline",{"points":"2 0 8 0 8 6","key":1})])))]);
}

External.defaultProps = {"width":"9px","height":"9px","viewBox":"0 0 9 9","version":"1.1"};

module.exports = External;

External.default = External;
